import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router';
import { useExperienceSearch } from '@/app/state/experienceSearch';
import { useActivityCategoryName } from '@/services/queries';

const ISO = /^\d{4}-\d{2}-\d{2}$/;

/** Reads `city`, `date` and `categoryId` once, into the experience search, then drops them from the URL. */
export function LegacyExperienceQuery() {
  const [params, setParams] = useSearchParams();
  const { update, markSearched } = useExperienceSearch();
  const categoryId = params.get('categoryId') ?? '';
  const category = useActivityCategoryName(categoryId);
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    const city = params.get('city');
    const date = params.get('date');
    if (!city && !date && !categoryId) return;
    if (categoryId && category.isPending) return; // wait for the category name
    done.current = true;
    update({
      ...(city ? { city } : {}),
      ...(date && ISO.test(date) ? { date } : {}),
      ...(category.data ? { category: category.data } : {}),
    });
    markSearched();
    setParams(
      (p) => {
        p.delete('city');
        p.delete('date');
        p.delete('categoryId');
        return p;
      },
      { replace: true },
    );
  }, [params, categoryId, category.isPending, category.data, update, markSearched, setParams]);

  return null;
}
